import { render, staticRenderFns } from "./crossTableStyle.vue?vue&type=template&id=21124308&scoped=true"
import script from "./crossTableStyle.vue?vue&type=script&lang=js"
export * from "./crossTableStyle.vue?vue&type=script&lang=js"
import style0 from "./crossTableStyle.vue?vue&type=style&index=0&id=21124308&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21124308",
  null
  
)

export default component.exports